import {ContentState, getContentProvider, getCurrentContent} from "./content_module";
import {ActionContext} from "vuex";
import {ExerciseStudent} from "../../../../presentation/views/content/helpers";

export class ExerciseState {
  exercise: ExerciseStudent | null = null;
  answeredQuestions: Set<number> = new Set<number>();
}

const state = new ExerciseState();

type ExerciseActionContext = ActionContext<ExerciseState, ContentState>;

const mutations = {
  SET_EXERCISE(state: ExerciseState, exercise: ExerciseStudent) {
    state.exercise = exercise;
  },
};

/** return the current content granting is not null. */
export const getCurrentContentExercise = (ctx: ActionContext<any, any>): ExerciseStudent => {
  const {exercise} = getCurrentContent(ctx);
  if (!exercise) throw new Error("[getCurrentContentExercise] Error !exercise");
  return exercise;
};

const actions = {
  async initializeModule(ctx: ExerciseActionContext) {
    const exercise = getCurrentContentExercise(ctx);
    ctx.commit("SET_EXERCISE", exercise);
  },

  async generateQuestionnaire(ctx: ExerciseActionContext): Promise<number> {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const exercise = getCurrentContentExercise(ctx);
      const questionnaireID = await provider.generateQuestionnaire(content.id);

      content.status.progress = 0;
      await ctx.dispatch("content_module/updateContentOnList", content, {root: true});

      exercise.status.doing = true;
      exercise.status.finished = false;
      exercise.status.userAttempts++;
      exercise.status.questionnaire.id = questionnaireID;
      exercise.status.questionnaire.createdAt = new Date().toString();
      exercise.status.questionnaire.finishedAt = null;
      exercise.status.questionnaire.questions.corrects = 0;
      exercise.status.questionnaire.questions.answered = 0;

      ctx.commit("SET_EXERCISE", exercise);

      return questionnaireID;
    } catch (e) {
      console.error("[generateQuestionnaire] Error ", e);
      throw e;
    }
  },

  async finishQuestionnaire(ctx: ExerciseActionContext): Promise<void> {
    try {
      await ctx.dispatch("content_module/finishContent", null, {root: true});
      const exercise = getCurrentContentExercise(ctx);
      exercise.status.doing = false;
      exercise.status.finished = true;
      exercise.status.questionnaire.finishedAt = new Date().toString();

      ctx.commit("SET_EXERCISE", exercise);
    } catch (e) {
      console.error("[generateQuestionnaire] Error ", e);
      throw e;
    }
  }
};

const getters = {
  exercise: (state: ExerciseState): ExerciseStudent | null => state.exercise,
  createdAt: (state: ExerciseState): string | null => {
    const exercise = state.exercise;
    if (!exercise) {
      return null;
    }
    return exercise.status.questionnaire.createdAt;
  },
  maximumTime: (state: ExerciseState): number | null => {
    const exercise = state.exercise;
    if (!exercise) {
      return null
    }
    return exercise.maximumTime;
  },
  remainingTime: (_: ExerciseState, {createdAt, maximumTime}): number | null => {
    if (!maximumTime || !createdAt) {
      return null;
    }

    const createdAtDate = new Date(createdAt);
    const maximumTimeMilliseconds = maximumTime * 1000; 
    const createdAtMilliseconds = createdAtDate.getTime();

    const expireTimeMilliseconds = createdAtMilliseconds + maximumTimeMilliseconds;

    const dateNow = new Date();
    const dateNowMilliseconds = dateNow.getTime();

    return expireTimeMilliseconds - dateNowMilliseconds;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}